import React, { useState, useRef } from "react";
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import "../about/SplashPdfViewer.css";
import CTAButton from "../components/sticky-button";
import PageHeader from "../about/PageHeader";

const Recruitment = () => {
  const topRef = useRef(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  
  // Updated content for Recruitment 2025-2026
const pdfList = [
  { 
    id: 1, 
    title: "Faculty Recruitment 2025-26", 
    subtitle: "Applications are invited for the Post of Professor, Associate Professor & Assistant Professor",
    // Updated path with the simplified filename
    src: "/pdf/Contact/Faculty-Recruitment.pdf", 
    isWeb: false 
  },
  { 
    id: 2, 
    title: "Staff Application Form", 
    subtitle: "Application are invited for the following posts for the Academic Year 2025 – 2026",
    src: "/pdf/Contact/Recruitment-2025.pdf", 
    
    isWeb: false 
  }
];

  const [activePdf, setActivePdf] = useState(pdfList[0]);

  const handlePdfSelection = (pdf) => {
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    window.scrollTo({ top: 0, behavior: "smooth" });

    if (pdf.isWeb) {
      window.open(pdf.src, "_blank");
    } else {
      setActivePdf(pdf);
    }
    setMobileOpen(false);
  };

  return (
    <>
      <Navbar />
      <CTAButton />

      <div className="spv-modern-portal">
        <div ref={topRef}>
          <PageHeader
            title="Recruitment" 
            crumbs={[{ label: 'Home', href: '/' }, { label: 'Recruitment' }]} 
          />
        </div>

        <div className="spv-main-content">
          <div 
            className={`spv-mobile-overlay ${mobileOpen ? "active" : ""}`}
            onClick={() => setMobileOpen(false)}
          />

          <aside className={`spv-sidebar-modern ${mobileOpen ? "mobile-open" : ""}`}>
            {/* Updated Header for Recruitment */}
            <div className="spv-sidebar-header-text">CURRENT OPENINGS</div>
            
            <nav className="spv-nav-group">
              {pdfList.map((pdf) => (
                <button
                  key={pdf.id}
                  className={`spv-nav-card ${activePdf.id === pdf.id ? "is-active" : ""}`}
                  onClick={() => handlePdfSelection(pdf)}
                >
                  <div className="spv-card-content">
                    <img 
                      src={pdf.isWeb ? "/images/icons/browser.svg" : "/images/icons/pdf.svg"} 
                      alt="icon" 
                      className="spv-doc-icon-img" 
                    />
                    <div className="spv-card-info" style={{ textAlign: 'left', flex: 1, paddingLeft: '10px' }}>
                      <span className="spv-card-text" style={{ display: 'block', fontWeight: 'bold' }}>{pdf.title}</span>
                      <small style={{ fontSize: '11px', color: '#666' }}>{pdf.subtitle}</small>
                    </div>
                    <img 
                      src="/images/icons/move.webp" 
                      alt="arrow icon" 
                      className="spv-doc-icon-img" 
                    />
                  </div>
                </button>
              ))}
            </nav>
          </aside>

<main className="spv-viewer-area" key={activePdf.id}>            <header className="spv-viewer-topbar" style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
              <div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}>
                <h2 className="spv-doc-title">{activePdf.title}</h2>
                <div className="spv-action-group">
                  <button 
                    className="spv-btn spv-btn-outline" 
                    onClick={() => window.open(activePdf.src)}
                  >
                    Full Screen
                  </button>
                </div>
              </div>
              
              {/* Important Announcement Text */}

            </header>

            <div className="spv-pdf-viewport">
              <div className="spv-pdf-card no-select">
                <iframe
                  src={`${activePdf.src}#toolbar=0&navpanes=0&scrollbar=0`}
                  className="spv-iframe-content secure-frame"
                  title="Recruitment Details"
                  onContextMenu={(e) => e.preventDefault()}
                />
              </div>
            </div>
          </main>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Recruitment;